import React, { useRef, useState, useEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import PortalPageTheme from './PortalPageTheme';

const Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  const location = useLocation();
  const mainRef = useRef(null);
  const [open, setOpen] = useState(() => !isMobile);

  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (isMobile) setOpen(false);
    mainRef.current?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search, isMobile]);

  return (
    <Box sx={{ display: 'flex', minHeight: '100dvh', height: { xs: '100dvh', md: '100vh' } }}>
      <Sidebar open={open} setOpen={setOpen} />
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', width: { xs: '100%', md: 'auto' } }}>
        <Topbar open={open} setOpen={setOpen} />
        <Box ref={mainRef} component="main" sx={{ flex: 1, minHeight: 0, p: { xs: 1.5, sm: 2, md: 3 }, overflow: 'auto' }}>
          <PortalPageTheme pathname={location.pathname}>{children}</PortalPageTheme>
        </Box>
      </Box>
    </Box>
  );
}

export default Layout;
